export const years = [1999, 2003, 2007, 2011, 2015]

export type DataType = {
  [key: string]: number[]
}
export const data: DataType = {
  A: [28.6, 27.5, 29.6, 31.7, 33.0],
  FRP: [12.1, 16.4, 17.5, 11.4, 9.5],
  H: [21.4, 18.1, 19.3, 28.0, 23.2],
  KRF: [9.3, 6.4, 6.4, 5.6, 5.4],
  MDG: [0.3, 0.2, 0.3, 0.9, 4.2],
  RØDT: [2.0, 1.6, 1.9, 1.5, 2.0],
  SP: [8.3, 7.9, 8.0, 6.7, 8.5],
  SV: [7.8, 12.4, 6.2, 4.1, 4.1],
  V: [4.4, 3.8, 5.9, 6.3, 5.5]
}
